<template>
  <nav>
    <a href="support" title="See all support options"><img src="@/assets/icon-standard-arrow-left.svg" alt="Back arrow icon">All Support</a>
  </nav>
</template>

<script>
  export default {
    name: "supportnav"
  }
</script>

<style lang="scss" scoped>
nav {
  display: flex;
  flex-flow: column nowrap;
  margin: 20px 0 30px;
  max-width: 679px;
  margin: 0 auto;
}

nav a {
  text-transform: uppercase;
  font-family: var(--rob);
  font-size: 1.125rem;
  line-height: 1.278;
  font-weight: 700;
  color: #333;
  text-decoration: none;
  border-bottom: 2px solid var(--black);
  border-top: 2px solid var(--black);
  padding: 7px 0;
  display: flex;
  justify-content: flex-start;
}

img {
  margin-right: 15px;
}

@media only screen and (min-width:1024px) {
  nav a {
    border: none;
  }
}
</style>